import merge from 'lodash.merge';
import { INavigationServices, NavigationStructure } from 'services';
import { normalize } from '@/lib/functions/other';
import { RouteObject } from 'router';
import { NodeData, TreeNode } from 'store';

class NavigationService implements INavigationServices {
	getStructure(routes: Array<RouteObject>): NavigationStructure {
		const [folderTree, folderData] = this.getNavigationTree(routes);

		return {
			folderTree: {
				key: 'root',
				children: folderTree
			},
			folderData: merge(folderData, {
				root: {
					key: 'root',
					isRoot: true
				}
			})
		};
	}

	/**
	 * builds navigation tree based on vuex route file
	 * @param {object} routes
	 * @param {*} currPath
	 * @param {*} folderTree
	 * @param {*} folderData
	 */
	getNavigationTree(
		routes: Array<RouteObject>,
		currPath = '',
		folderTree: Array<TreeNode> = [],
		folderData: Record<string, NodeData> = {}
	): [Array<TreeNode>, Record<string, NodeData>] {
		routes.forEach((route: RouteObject) => {
			if (route.inNavigation === false) {
				return;
			}

			const componentPath = normalize(`${currPath}/${route.path}`);
			const key = route.key;
			const name = route.title ?? route.name;
			const exact = !!route?.exact;
			const versionValidator = route?.meta?.versionValidator;

			if (route.children) {
				const dirConfig = {
					key,
					children: []
				};
				let children = folderTree;

				folderTree.push(dirConfig);
				folderData[key] = {
					...dirConfig,
					title: name,
					exact,
					versionValidator
				};

				children = dirConfig.children;

				this.getNavigationTree(route.children, route.path, children, folderData);
			} else {
				folderTree.push({
					key
				});

				folderData[key] = merge({
					key,
					title: name,
					path: componentPath,
					exact,
					versionValidator
				});
			}
		});

		return [folderTree, folderData];
	}
}

export default NavigationService;
